import React, { useMemo, useEffect, useState, useCallback } from "react";
import {
  FaCheckCircle,
  FaChevronRight,
  FaLock,
  FaHeadset,
  FaShieldAlt,
} from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
const studentPlans = [
  {
    id: {
      180: 1036,
      365: 1037,
      730: 1038,
    },
    name: "SAPPHIRE ELITE",
    prices: {
      180: 40250,
      365: 58650,
      730: 113850,
    },
    medicalCoverageLimit: "150,000",
    features: [
      "Enhanced medical coverage",
      "Trip cancellation",
      "24/7 assistance",
    ],
  },

  {
    id: {
      180: 1039,
      365: 1040,
      730: 1041,
    },
    name: "SAPPHIRE PLUS",
    prices: {
      180: 20120,
      365: 29320,
      730: 56920,
    },
    medicalCoverageLimit: "100,000",

    features: [
      "Enhanced medical coverage",
      "Trip cancellation",
      "24/7 assistance",
    ],
  },
  {
    id: {
      180: 1042,
      365: 1043,
      730: 1044,
    },
    name: "SAPPHIRE",
    prices: {
      180: 14950,
      365: 21850,
      730: 42550, // 2 Years = 730 Days
    },
    medicalCoverageLimit: "50,000",

    features: ["Basic medical coverage", "24/7 assistance"],
  },
];
const CenteredModal = ({ show, handleClose }) => {
  const iframeSrc = `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent("https://webdoc.com.pk/assets/documents/DIGI-Travel-Insurance.pdf")}`;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      dialogClassName="terms-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Terms And Conditions</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 0, height: "70vh" }}>
        <iframe
          src={iframeSrc}
          className="terms-iframe"
          title="Terms Content"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
const PlanSelection = ({
  setStep,
  age,
  duration,
  zone,
  coverageType,
  travelType,
  startDate,
  endDate,
  soloData,
  family,
}) => {
  const [pkrRate, setPkrRate] = useState(280); // fallback rate
  const [rateStatus, setRateStatus] = useState("loading");
  const [showAllCoverage, setShowAllCoverage] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState();
  const [durationIndex, setDurationIndex] = useState(0);
  const [baseRate, setBaseRate] = useState(0);
  const [isPlanLocked, setIsPlanLocked] = useState(false);
  const navigate = useNavigate();
  // useEffect(() => {
  //   fetch("https://open.er-api.com/v6/latest/USD")
  //     .then((r) => r.json())
  //     .then((data) => {
  //       if (data?.rates?.PKR) {
  //         setPkrRate(parseFloat(data.rates.PKR.toFixed(4)));
  //         setRateStatus("live");
  //       } else {
  //         setRateStatus("fallback");
  //       }
  //     })
  //     .catch(() => setRateStatus("fallback"));
  // }, [age, duration, zone, coverageType, travelType]);
  // 🔥 AGE LOADING FUNCTION
  const getAgeLoading = (age) => {
    if (age <= 65) return { rate: 0, label: "No loading", note: "No loading" };
    if (age <= 75)
      return {
        rate: 0.5,
        label: "+50%",
        note: "Health declaration required",
      };
    if (age <= 80)
      return {
        rate: 0.75,
        label: "+75%",
        note: "Health declaration required",
      };
    if (age <= 85)
      return {
        rate: 1.0,
        label: "+100%",
        note: "Health declaration + SIMA preapproval",
      };
    if (age <= 90)
      return {
        rate: 2.0,
        label: "+200%",
        note: "Health declaration + SIMA preapproval",
      };
    return null;
  };
  const RATES = {
    0: {
      // Elite
      0: [
        // Individual
        [20.7, 17.4, 14.7],
        [23.8, 20.2, 17.2],
        [29.7, 25.3, 21.6],
        [34.2, 29.2, 24.9],
        [42.0, 35.8, 30.3],
        [65.3, 55.6, 47.3],
        [75.4, 64.0, 54.5],
        [90.3, 76.6, 65.2],
        [105.2, 89.3, 76.0],
        [132.7, 112.8, 95.8],
        [146.3, 124.4, 105.7],
        [160.1, 136.2, 115.7],
        [240.2, 204.5, 173.7],
        [320.2, 272.3, 231.3],
        [412.5, 352.0, 297.0],
      ],
      1: [
        // Family
        [39.4, 29.7, 23.8],
        [45.1, 34.5, 27.6],
        [56.3, 43.0, 34.5],
        [65.0, 49.6, 39.7],
        [79.9, 60.7, 48.4],
        [124.2, 88.8, 75.7],
        [143.1, 108.9, 84.5],
        [171.6, 130.5, 103.1],
        [199.9, 151.9, 121.7],
        [252.0, 191.6, 153.3],
        [278.1, 211.5, 169.2],
        [304.2, 231.4, 185.0],
        [456.2, 347.3, 277.5],
        [608.4, 463.0, 370.0],
        [775.5, 666.6, 562.1],
      ],
    },
    1: {
      // Platinum
      0: [
        [18.8, 15.8, 13.4],
        [21.6, 18.4, 15.6],
        [27.0, 23.0, 19.6],
        [31.1, 26.5, 22.6],
        [38.2, 32.5, 27.5],
        [59.4, 50.5, 43.0],
        [68.5, 58.2, 49.5],
        [82.1, 69.6, 59.3],
        [95.6, 81.2, 69.1],
        [120.6, 102.5, 87.1],
        [133.0, 113.1, 96.1],
        [145.5, 123.8, 105.2],
        [218.4, 185.9, 157.9],
        [291.1, 247.5, 210.3],
        [374.0, 319.0, 269.5],
      ],
      1: [
        [35.8, 27.0, 21.6],
        [41.0, 31.4, 25.1],
        [51.2, 39.1, 31.4],
        [59.1, 45.1, 36.1],
        [72.6, 55.2, 44.0],
        [112.9, 80.7, 68.8],
        [130.1, 99.0, 76.8],
        [156.0, 118.6, 93.7],
        [181.7, 138.1, 110.6],
        [229.1, 174.2, 139.4],
        [253.0, 192.5, 154.0],
        [276.5, 210.4, 168.2],
        [414.7, 315.7, 252.3],
        [553.1, 420.9, 336.4],
        [705.0, 606.1, 511.5],
      ],
    },
    2: {
      // Gold
      0: [
        [9.1, 7.7, 6.5],
        [11.4, 9.7, 8.4],
        [13.9, 11.9, 10.1],
        [16.8, 14.3, 12.3],
        [22.3, 19.0, 16.1],
        [28.2, 24.0, 20.4],
        [40.8, 34.7, 29.5],
        [50.5, 43.0, 36.5],
        [60.2, 51.3, 43.6],
        [61.3, 52.1, 44.3],
        [61.8, 52.6, 44.7],
        [62.4, 53.0, 45.1],
        [93.5, 79.6, 67.7],
        [124.7, 106.0, 90.2],
        [261.8, 223.3, 188.7],
      ],
      1: [
        [17.3, 13.1, 10.8],
        [21.8, 16.5, 12.4],
        [26.3, 20.2, 15.2],
        [32.0, 24.2, 19.7],
        [42.5, 32.3, 23.2],
        [53.5, 40.7, 34.7],
        [73.4, 59.0, 51.6],
        [81.8, 73.2, 58.5],
        [90.3, 87.2, 65.3],
        [101.3, 88.7, 67.7],
        [106.8, 89.4, 68.8],
        [112.3, 90.2, 70.0],
        [168.5, 135.3, 104.9],
        [224.6, 180.4, 139.9],
        [497.4, 424.3, 363.0],
      ],
    },
    3: {
      // Silver
      0: [
        [5.9, 5.3, 4.2],
        [7.4, 6.5, 5.4],
        [9.1, 8.1, 6.5],
        [10.9, 9.8, 7.9],
        [13.6, 12.1, 9.9],
        [18.4, 16.5, 13.3],
        [23.8, 21.3, 17.3],
        [28.1, 25.1, 20.4],
        [32.2, 28.8, 23.3],
        [41.1, 36.9, 29.7],
        [45.5, 40.8, 32.9],
        [49.9, 44.8, 36.1],
        [74.9, 67.1, 54.1],
        [99.9, 89.5, 72.2],
        [187.0, 160.8, 137.5],
      ],
      1: [
        [11.3, 8.9, 6.6],
        [14.0, 10.7, 8.6],
        [17.3, 12.2, 10.5],
        [20.7, 16.2, 12.7],
        [26.0, 20.6, 15.8],
        [35.0, 28.1, 21.2],
        [45.1, 36.2, 26.6],
        [53.2, 42.7, 32.0],
        [61.3, 49.1, 37.4],
        [78.1, 62.6, 47.5],
        [86.5, 69.3, 52.6],
        [94.8, 76.0, 57.6],
        [143.0, 114.1, 86.5],
        [189.6, 152.0, 115.3],
        [358.2, 305.5, 260.7],
      ],
    },
    4: {
      // Standard
      0: [
        [3.0, 2.8, 2.2],
        [3.5, 3.2, 2.5],
        [4.2, 3.7, 3.0],
        [6.4, 5.8, 4.5],
        [7.2, 6.3, 5.2],
        [12.9, 11.6, 9.4],
        [16.8, 15.1, 12.1],
        [22.6, 20.2, 16.3],
        [28.2, 25.3, 20.4],
        [33.2, 29.8, 24.0],
        [35.6, 32.0, 25.7],
        [38.2, 34.3, 27.5],
        [57.3, 51.5, 41.3],
        [76.3, 68.6, 55.0],
        [150.8, 128.6, 108.7],
      ],
      1: [
        [5.6, 4.4, 3.5],
        [6.8, 4.7, 4.1],
        [7.9, 5.3, 4.7],
        [12.0, 7.4, 6.6],
        [13.5, 8.8, 7.9],
        [24.4, 16.1, 14.9],
        [32.0, 27.1, 19.4],
        [42.8, 35.1, 26.1],
        [53.5, 43.0, 32.7],
        [63.0, 49.0, 38.4],
        [68.2, 51.9, 41.1],
        [72.6, 54.9, 44.0],
        [108.9, 82.5, 66.0],
        [145.2, 109.8, 88.0],
        [286.6, 244.4, 206.5],
      ],
    },
  };
  const PLAN_NAMES = ["Elite", "Platinum", "Gold", "Silver", "Standard"];
  const PLAN_IDS = ["1031", "1032", "1033", "1034", "1035"]; // placeholder backend IDs
  const MEDICAL_LIMITS = [
    "$150,000",
    "$100,000",
    "$50,000",
    "$25,000",
    "$10,000",
  ];
  const PASSPORT_LIMITS = ["$600", "$500", "$400", "$300", "$200"];
  const PA_LIMITS = ["$30,000", "$25,000", "$20,000", "$10,000", "$5,000"];
  const ZONE_LABELS = [
    "Zone 1 — Worldwide incl USA / Canada / Australia",
    "Zone 2 — Worldwide excl USA / Canada / Australia",
    "Zone 3 — Europe",
  ];
  const getZoneIndex = (countryCode) => {
    const zone1 = ["US", "CA", "AU"];
    const ZONE_3 = [
      "AT",
      "BE",
      "BG",
      "HR",
      "CY",
      "CZ",
      "DK",
      "EE",
      "FI",
      "FR",
      "DE",
      "GR",
      "HU",
      "IE",
      "IT",
      "LV",
      "LT",
      "LU",
      "MT",
      "NL",
      "PL",
      "PT",
      "RO",
      "SK",
      "SI",
      "ES",
      "SE",
    ];

    if (zone1.includes(countryCode)) return 0; // Worldwide incl US
    if (ZONE_3.includes(countryCode)) return 2; // Europe
    return 1;
  };
  const DURATION_LABELS = [
    "Up to 7 Days",
    "Up to 10 Days",
    "Up to 15 Days",
    "Up to 21 Days",
    "Up to 31 Days",
    "Up to 62 Days",
    "Up to 92 Days",
    "6 Months (Max 92 days/trip)",
    "6 Months (Max 180 days/trip)",
    "9 Months (Max 92 days/trip)",
    "9 Months (Max 180 days/trip)",
    "1 Year (Max 180 days/trip)",
    "2 Years (Max 92 days/trip)",
    "2 Years (Max 180 days/trip)",
    "Long Stay — 1 Year (365 days)",
  ];
  const COVERAGE_DETAILS = [
    [
      "Emergency Medical (Accident/Illness)",
      selectedPlan?.features.Medical,
      true,
    ],
    ["COVID-19 Emergency Medical", "$35,000 (all plans)", false],
    ["Emergency Dental Care", "$600 (Excess: $60)", false],
    ["Medical Evacuation & Repatriation", "Actual Expenses", true],
    ["Repatriation of Mortal Remains", "Actual Expenses", true],
    ["Compassionate Visit(Family Member)", "$100/day, Max $1,000", false],
    ["Trip Cancellation", "$1,000", false],
    ["Delayed Departure", "$1,000", false],
    ["Loss of Checked-In Luggage", "$1,000", false],
    ["Loss of Passport", selectedPlan?.features.Passport_Loss, false],
    ["Loss of Credit Card (first 24 hrs)", "$2,000", false],
    [
      "Accidental Death (Common Carrier)",
      selectedPlan?.features.Personal_Accident,
      false,
    ],
    ["Bail Bond Advance", "$12,000", false],
    ["24/7 Assistance Services", "Included", true],
  ];
  const AGE_LOADING_TABLE = [
    {
      range: "Up to 65 years",
      pct: "0%",
      label: "Standard Premium",
      note: "No loading",
    },
    {
      range: "66 – 75 years",
      pct: "+50%",
      label: "+50%",
      note: "Health declaration required",
    },
    {
      range: "76 – 80 years",
      pct: "+75%",
      label: "+75%",
      note: "Health declaration required",
    },
    {
      range: "81 – 85 years",
      pct: "+100%",
      label: "+100%",
      note: "Health declaration + SIMA preapproval",
    },
    {
      range: "86 – 90 years",
      pct: "+200%",
      label: "+200%",
      note: "Health declaration + SIMA preapproval",
    },
  ];
  const getDurationIndex = (duration, coverageType) => {
    if (duration <= 7) return 0;
    if (duration <= 10) return 1;
    if (duration <= 15) return 2;
    if (duration <= 21) return 3;
    if (duration <= 31) return 4;
    if (duration <= 62) return 5;
    if (duration <= 92) return 6;

    // 🔥 Now handle > 92 properly

    if (duration <= 180) {
      return coverageType === "limited" ? 7 : 8;
    }

    if (duration <= 270) {
      return coverageType === "limited" ? 9 : 10;
    }

    if (duration <= 365) {
      if (coverageType === "limited") return 11; // 1 year (180 max)
      return 14; // 1 year full (365)
    }

    if (duration <= 730) {
      return coverageType === "limited" ? 12 : 13;
    }

    return 14;
  };
  const KEY_NOTES = [
    "Policy valid for insured aged 30 days – 85 years (86–90 requires SIMA preapproval).",
    "Maximum trip duration: 180 consecutive days per trip.",
    "Family = 2 named adults under 65 + any number of children under 18, travelling together.",
    "COVID-19 covered only if PCR+ ≥72 hours after arrival at destination; max 10 days hospitalisation.",
    "One-way tickets and open tickets are NOT covered; return ticket must be booked before departure.",
    "Policy extension available up to 62 days (+100% of paid premium, 7-day waiting period).",
    "Claims must be submitted within 30 days of occurrence / first treatment.",
    "Pre-existing, congenital, chronic, and psychiatric conditions are excluded.",
  ];
  const generatePlans = ({
    age,
    duration,
    countryCode,
    travelType = 0, // 0 = Individual, 1 = Family
  }) => {
    const zoneIndex = getZoneIndex(countryCode);

    const durationIndex = getDurationIndex(duration, coverageType); // assuming already index (0–14)
    setDurationIndex(durationIndex);
    const plans = PLAN_NAMES.map((name, i) => {
      const base = RATES?.[i]?.[travelType]?.[durationIndex]?.[zoneIndex];

      if (!base) return null;
      setBaseRate(base);
      const ageInfo = getAgeLoading(age);
      if (!ageInfo) return null;

      const final = base * (1 + ageInfo.rate);
      return {
        id: PLAN_IDS[i],
        name,
        price: Math.round(final * pkrRate).toLocaleString("en-PK"),
        basePrice: base,
        ageInfo,
        zone: ZONE_LABELS[zoneIndex],
        features: {
          Medical: MEDICAL_LIMITS[i],
          Passport_Loss: PASSPORT_LIMITS[i],
          Personal_Accident: PA_LIMITS[i],
        },
      };
    });

    return plans.filter(Boolean);
  };

  const plansData = useMemo(() => {
    if (travelType !== "Student") {
      return generatePlans({
        age,
        duration,
        countryCode: zone, // "AX"
        travelType: travelType === "Family" ? 1 : 0, // or 1 for family
      });
    }
  }, [pkrRate]);

  // const handlePayNow = useCallback(async () => {
  //   const pkrAmount = Math.round(
  //     selectedPlan.basePrice * pkrRate,
  //   ).toLocaleString("en-PK");

  //   const TRAVEL_API_BASE =
  //     "https://miniappeasypaisa.webddocsystems.com/public/api/v1";
  //   try {
  //     const form = new FormData();
  //     form.append(
  //       "value",
  //       travelType === "Student" ? selectedPlan.price : pkrAmount,
  //     );
  //     form.append("apikey", "Travel");
  //     const userData = JSON.parse(sessionStorage.getItem("user"));
  //     console.log(userData, "userdata from session storage", selectedPlan);
  //     const metadata = {
  //       customerNumber: userData.userMsisdn,
  //       openID: "oW1234xyzABCDEF",
  //       unionID: "uW1234xyzABCDEF",
  //       customerName: userData.userName,
  //       planID: selectedPlan.id,
  //       planName: selectedPlan.name,
  //       coverageZone: 0,
  //       coverageZoneLabel: selectedPlan.zone,
  //       coverageType: 0,
  //       coverageTypeLabel: travelType,
  //       durationIndex: durationIndex,
  //       durationLabel: DURATION_LABELS[durationIndex],
  //       ageOfInsured: age,
  //       basePremiumUSD: baseRate,
  //       ageLoadingRate: selectedPlan?.ageInfo?.rate,
  //       ageLoadingLabel: selectedPlan?.ageInfo?.note,
  //       finalPremiumUSD: selectedPlan?.basePrice,
  //       usdToPkrRate: Number(pkrRate),
  //       finalPremiumPKR: Number(
  //         typeof selectedPlan?.price === "string"
  //           ? selectedPlan.price.replace(/,/g, "")
  //           : selectedPlan?.price || 0,
  //       ),
  //       medicalDeductibleUSD: 100,
  //       medicalCoverageLimit: selectedPlan?.features?.Medical,
  //       transactionID: `TXN202${Date.now()}`,
  //       paymentStatus: "SUCCESS",
  //       paymentResultCode: "000",
  //       // 🔥 REPLACE WITH ACTUAL CUSTOMER NUMBER
  //     };
  //     console.log(selectedPlan, "metadata ---------", metadata);

  //     const resp = await fetch(
  //       "https://miniappeasypaisa.webddocsystems.com/public/api/v1/travel-insurance/subscribe",
  //       {
  //         method: "POST",

  //         body: JSON.stringify(metadata),
  //       },
  //     );
  //     const data = await resp.json();
  //     if (data.responseCode === "0000") {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Subscription Successful",
  //         text: "Your travel insurance subscription was successful!",
  //       });
  //       setStep(1);
  //     } else {
  //       Swal.fire({
  //         title: "Error!",
  //         text: "There was an error unsubscribing from the service. Please try again later.",
  //         icon: "error",
  //         confirmButtonText: "OK",
  //         allowOutsideClick: false,
  //       });
  //     }
  //     return;
  //     form.append("metadata", JSON.stringify(metadata));
  //     const response = await fetch(`${TRAVEL_API_BASE}/create-payment`, {
  //       method: "POST",
  //       body: form,
  //     });
  //     const res = await response.json();

  //     if (res.paymentTransactionID) {
  //       window.mp.createPayment(res.paymentTransactionID);
  //       setStep(1);
  //     }
  //   } catch (error) {
  //     console.error("Payment error:", error);
  //   } finally {
  //   }
  // }, [selectedPlan, zone, duration, age]);

  const formatApiDate = (dateStr) => {
    if (!dateStr) return null;
    const [d, m, y] = dateStr.split(" - ");
    return `${y}-${m}-${d}`;
  };

  const handlePayNow = async () => {
    const TRAVEL_API_BASE =
      "https://miniappeasypaisa.webddocsystems.com/public/api/v1";
    try {
      const userData = JSON.parse(sessionStorage.getItem("user"));

      const zoneIndex = getZoneIndex(zone);

      const payload = {
        customerNumber: userData.userMsisdn,
        openID: userData.openId,
        unionID: userData.unionId,
        customerName: userData.userName,

        planID: selectedPlan.id,
        planName: selectedPlan.name,

        coverageZone: zoneIndex,
        coverageZoneLabel: zone,

        coverageType: travelType === "Family" ? 1 : 0,
        coverageTypeLabel: travelType === "Solo" ? "Individual" : travelType,

        durationIndex: durationIndex,
        durationLabel: DURATION_LABELS[durationIndex],

        tripStartDate: formatApiDate(startDate),
        tripEndDate: formatApiDate(endDate),

        ageOfInsured: age,

        basePremiumUSD: selectedPlan?.basePrice || selectedPlan?.price,
        ageLoadingRate: selectedPlan?.ageInfo?.rate || 0,
        ageLoadingLabel: selectedPlan?.ageInfo?.label || "No loading",

        finalPremiumUSD: selectedPlan.basePrice || selectedPlan?.price,
        usdToPkrRate: Number(pkrRate),

        finalPremiumPKR: Number(
          selectedPlan.price.toString().replace(/,/g, ""),
        ),

        medicalDeductibleUSD: 100,
        medicalCoverageLimit:
          selectedPlan?.features?.Medical || selectedPlan?.medicalCoverageLimit,

        transactionID: `TXN${Date.now()}`,
        paymentStatus: "SUCCESS",
        paymentResultCode: "000",
      };
      payload.beneficiaryName = soloData.beneficiaryName;
      payload.beneficiaryCNIC = soloData.cnic;
      payload.relation = soloData.relation;
      // ✅ SOLO extra fields
      if (travelType === "Student" || travelType === "Solo") {
        payload.passport = soloData.passport;
        payload.passportExpiry = soloData.passport_expiry;
      }

      // ✅ FAMILY extra fields
      if (travelType === "Family") {
        payload.wifeName = family.wife.name;
        payload.wifeCNIC = family.wife.cnic;
        payload.wifePassport = family.wife.passport;

        if (family.wife?.name && family.wife?.passport) {
          payload.wifeName = family.wife.name;
          payload.wifePassport = family.wife.passport;
          payload.wifeCNIC = family.wife.cnic || "";
        }

        payload.kidsDetails = family.kids
          .filter((kid) => kid.name && kid.passport) // remove empty
          .map((kid) => ({
            name: kid.name,
            passport: kid.passport,
          }));
      }

      // navigate(`/confirm`, {
      //   state: {
      //     apiKey: "Travel",
      //     type: "insurance",
      //     payload,
      //     pid: selectedPlan.id,
      //     status: "S", // Default status to "S" if missing
      //     code: "SUCCESS", // Default code to "SUCCESS" if missing
      //     tid: "1123123", // Fallback transaction ID
      //   },
      // });
      // return;

      const form = new FormData();
      form.append("value", Number(selectedPlan.price.replace(/[^0-9.]/g, "")));
      form.append("apikey", "Travel");
      const response = await fetch(`${TRAVEL_API_BASE}/create-payment`, {
        method: "POST",
        body: form,
      });
      const res = await response.json();
      if (res.paymentTransactionID) {
        window.mp.createPayment(res.paymentTransactionID);
        window.createPaymentResult = (jsonResult) => {
          const result = JSON.parse(jsonResult);
          navigate(`/confirm`, {
            state: {
              apiKey: "Travel",
              type: "insurance",
              payload,
              pid: selectedPlan.id,
              status: result.paymentStatus || "S", // Default status to "S" if missing
              code: result.resultCode || "SUCCESS", // Default code to "SUCCESS" if missing
              tid: result.paymentTransactionID || "1123123", // Fallback transaction ID
            },
          });
        };
      }

      // const resp = await fetch(
      //   `${TRAVEL_API_BASE}/travel-insurance/subscribe`,
      //   {
      //     method: "POST",
      //     // headers: {
      //     //   "Content-Type": "application/json",
      //     // },
      //     body: JSON.stringify(payload),
      //   },
      // );

      // const data = await resp.json();

      // if (data.responseCode === "0000") {
      //   Swal.fire({
      //     icon: "success",
      //     title: "Subscription Successful",
      //     text: "Your travel insurance subscription was successful!",
      //   });
      //   setStep(1);
      // } else {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Error",
      //     text: data.message || "Subscription failed",
      //   });
      // }
    } catch (error) {
      console.error("Payment error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
      });
    }
  };

  const getValidDuration = (duration) => {
    if (duration < 180) return 180;
    if (duration < 365) return 365;
    if (duration < 730) return 730;
    return 730; // fallback for anything beyond 730
  };
  console.log(selectedPlan, "plansData", isPlanLocked);
  return (
    <>
      <h2 className="text-center font-bold mb-4 text-xl md:text-2xl">
        Choose Your Plan
      </h2>

      {/* Exchange Rate Banner */}
      {/* <div className="mb-3">
        <div
          className={`flex items-center justify-between px-3 py-2 rounded-md text-xs border ${rateStatus === "live"
            ? "bg-green-50 border-green-200"
            : "bg-yellow-50 border-yellow-400"
            }`}
        >
          <span className="text-[#6b6254]">
            {rateStatus === "loading" && "⏳ Fetching live exchange rate…"}
            {rateStatus === "live" && "🟢 Live rate · 1 USD ="}
            {rateStatus === "fallback" && "⚠️ Using offline rate · 1 USD ="}
          </span>

          {rateStatus !== "loading" && (
            <span className="font-bold text-[#0d4f5c]">
              PKR {pkrRate.toLocaleString("en-PK")}
            </span>
          )}
        </div>
      </div> */}

      {/* Plans */}
      {travelType === "Student" ? (
        <>
          {studentPlans
            ?.filter((plan) => {
              const validDuration = getValidDuration(duration);
              const planId = plan.id[validDuration];

              return !selectedPlan || selectedPlan?.id === planId;
            })
            .map((plan) => {
              const validDuration = getValidDuration(duration);
              const planId = plan.id[validDuration];
              const planPrice = plan.prices[validDuration];
              const isSelected = selectedPlan?.id === planId;

              const handleSelect = () => {
                setSelectedPlan((prev) =>
                  prev?.id === planId
                    ? null
                    : {
                        ...plan,
                        id: planId,
                        price: planPrice,
                      },
                );
              };

              return (
                <div
                  key={planId}
                  className={`flex flex-col p-4 mb-3 relative rounded-xl shadow-sm cursor-pointer transition ${
                    isSelected
                      ? "outline-2 outline-yellow-400"
                      : "outline outline-gray-300"
                  }`}
                  onClick={handleSelect}
                >
                  {plan.name === "SAPPHIRE PLUS" && (
                    <div className="badge-popular">Most Popular</div>
                  )}

                  <div className="flex justify-between gap-4">
                    <div>
                      <h6 className="font-semibold">{plan.name}</h6>

                      {plan.features.map((f, i) => (
                        <p key={i} className="text-sm flex items-center">
                          <FaCheckCircle className="text-yellow-400 mr-2" />
                          {f}
                        </p>
                      ))}
                    </div>

                    <div className="text-right">
                      <h6 className="font-semibold">
                        PKR {planPrice.toLocaleString("en-PK")}
                      </h6>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="mt-3 w-full py-2 rounded-xl bg-amber-400 text-black"
                    onClick={(e) => {
                      e.stopPropagation(); // ✅ prevents double trigger
                      handleSelect();
                    }}
                  >
                    {isSelected ? (
                      <div className="flex items-center justify-center gap-1 font-semibold">
                        <FaCheckCircle /> Selected
                      </div>
                    ) : (
                      "Select"
                    )}
                  </button>
                </div>
              );
            })}
        </>
      ) : (
        <>
          {plansData
            ?.filter((plan) => !selectedPlan || selectedPlan?.id === plan.id)
            .map((plan) => (
              <div
                key={plan.id}
                className={`flex flex-col p-4 mb-3 relative rounded-xl shadow-sm cursor-pointer transition ${
                  selectedPlan?.id === plan.id
                    ? "outline-2 outline-yellow-400"
                    : "outline outline-gray-300"
                }`}
                onClick={() => {
                  setSelectedPlan((prev) =>
                    prev?.id === plan.id ? null : plan,
                  );
                }}
              >
                {plan.id === 0 && (
                  <div className="badge-popular">Most Popular</div>
                )}

                <div className="flex justify-between gap-4">
                  <div>
                    <h6 className="font-semibold">{plan.name}</h6>

                    {Object.entries(plan.features).map(([key, value], i) => (
                      <p key={i} className="text-sm flex items-center">
                        <FaCheckCircle className="text-yellow-400 mr-2" />
                        <span className="font-medium mr-1">
                          {key.replace(/_/g, " ")}:
                        </span>
                        {value}
                      </p>
                    ))}
                  </div>

                  <div className="text-right">
                    <h6 className="font-semibold">PKR {plan.price}</h6>
                  </div>
                </div>

                <button
                  className="mt-3 w-full py-2 rounded-2xl! bg-amber-400 text-black"
                  onClick={(e) => {
                    e.stopPropagation();

                    setSelectedPlan((prev) =>
                      prev?.id === plan.id ? null : plan,
                    );
                  }}
                >
                  {selectedPlan?.id === plan.id ? (
                    <div className="flex items-center justify-center gap-1 font-semibold">
                      <FaCheckCircle className="text-green-500" /> Selected
                    </div>
                  ) : (
                    "Select"
                  )}
                </button>
              </div>
            ))}
        </>
      )}

      {/* Coverage */}
      <div className="border rounded-2xl shadow-sm mt-4 p-3">
        <h6 className="text-sm mb-2">Whats Covered</h6>

        <div className="bg-white rounded-lg">
          {(showAllCoverage
            ? COVERAGE_DETAILS
            : COVERAGE_DETAILS.slice(0, 3)
          ).map(([label, value, green]) => (
            <div
              key={label}
              className="flex justify-between items-center py-2 border-b border-gray-300"
            >
              <span className="text-xs flex items-center">
                <BiSolidChevronRightCircle className="text-green-600 mr-2" />
                {label}
              </span>

              <span
                className={`font-bold text-[10px] ${
                  green ? "text-green-800" : "text-[#0d4f5c]"
                }`}
              >
                {value}
              </span>
            </div>
          ))}

          {COVERAGE_DETAILS.length > 3 && (
            <div className="text-center mt-2">
              <button
                className={`px-3 py-1 rounded! text-sm text-gray-800 ${
                  showAllCoverage ? "bg-yellow-300 " : "bg-yellow-400 "
                }`}
                onClick={() => setShowAllCoverage(!showAllCoverage)}
              >
                {showAllCoverage ? "Show Less ▲" : "Show More ▼"}
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Back */}
      <button
        className="w-full mt-3 py-2 rounded-xl! font-semibold bg-amber-400 text-black"
        onClick={() => setStep(1)}
      >
        Back
      </button>

      {/* Payment Summary */}
      <div className="border rounded-2xl shadow-sm text-center mt-4 p-4">
        <h6 className="font-semibold">
          PKR {selectedPlan?.price.toLocaleString("en-PK")}
        </h6>

        <button
          onClick={() => setShowTerms(true)}
          className="text-sm font-medium text-blue-600 "
        >
          Terms & Conditions
        </button>

        <button
          className="w-full mt-2 py-2 rounded-xl! bg-amber-400 text-black font-semibold disabled:opacity-50"
          disabled={!selectedPlan}
          onClick={handlePayNow}
        >
          Pay Now <FaChevronRight className="inline ml-1" />
        </button>

        <div className="flex justify-between items-center mt-3 text-gray-500 text-xs">
          <div className="flex items-center gap-1">
            <FaLock />
            <span>Secure Payment</span>
          </div>

          <div className="flex items-center gap-1">
            <FaHeadset />
            <span>24/7 Support</span>
          </div>

          <div className="flex items-center gap-1">
            <FaShieldAlt />
            <span>Trusted by 10,000+</span>
          </div>
        </div>

        <CenteredModal
          show={showTerms}
          handleClose={() => setShowTerms(false)}
        />
      </div>
    </>
  );
};

export default PlanSelection;
